import { useNavigate } from 'react-router-dom'
import React from 'react'
import { trackEvent } from 'analytics/trackFunctions'
import {
  scoreColors,
  scoreTextColors,
  scoringText
} from 'constants/creditScore'
import CreditScoreCard from './CreditScoreCard'
import EmojiSelector from './EmojiSelector'

const CapacityCard = ({ score = 1 }) => {
  const navigate = useNavigate()

  return (
    <CreditScoreCard
      rightButtonAction={() => {
        trackEvent({ eventName: 'bille_sc_boton_cp' })
        navigate('/perfil-crediticio/capacidad-de-pago')
      }}
      title='Tu capacidad de pago actual'
      datatestid='capacityCard'
    >
      <div className='flex gap-2 items-center my-4'>
        <div
          className={`rounded-full flex align-middle items-center justify-center h-9 w-9 ${scoreColors[score]}`}
        >
          <EmojiSelector size='SMALL' score={score} />
        </div>
        <p className={`font-bold text-xl ${scoreTextColors[score]}`}>
          {scoringText[score].title}
        </p>
      </div>
      <p className='text-2xs text-black'>
        *Según la última actualización del Banco Central
      </p>
    </CreditScoreCard>
  )
}

export default CapacityCard
